import Vue from 'vue'
import VueRouter from 'vue-router'

import SignupView from '../views/SignupView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/signup/'
  },
  {
    path: '/signup/',
    name: 'account_signup',
    component: SignupView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
